<template>
  <div class="c-sidenav">
    <div class="c-sidenav__toggle c-sidenav__toggle--profile" @click="handleClick()" data-test="sidenav-profile">
      <div class="btn btn-icon btn-outline btn-outline--white">
        <svg class="icon icon-profile"><use xlink:href="#icon-profile"></use></svg>
      </div>

      <span class="c-sidenav__username" v-if="user.isAuthenticated" data-test="sidenav-username">Hi, {{ user.name }}</span>
    </div>

    <div class="c-sidenav__body" v-if="user.isAuthenticated">
      <div class="c-sidenav__content">
        <profile-nav ref="profileNav"></profile-nav>
      </div>
    </div>
  </div>
</template>

<script>
  // Vuex
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'SideNav',
    
    components: {
      ProfileNav: () => import(/* webpackChunkName: "ProfileNav" */'./ProfileNav.vue')
    },
    
    computed: {
      ...mapGetters([
        'global',
        'user'
      ]),

      loginUrl () {
        return Laravel.portalUrl;
      }
    },

    methods: {
      ...mapActions([
        'openSideNav',
        'closeSideNav'
      ]),

      handleClick () {
        if (!this.user.isAuthenticated) return window.location.replace(Laravel.portalUrl);

        if (this.$mq('sm-max')) return this.global.isSideNavActive ? this.closeSideNav() : this.openSideNav();

        this.$refs.profileNav.$el.click();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/SideNav.vue